import { useState, useCallback } from "react";
import Heading from "@core/components/title/Heading";
import NcfzLogin from "@features/auth/component/userInfo/beforeLogin/NcfzLogin";
import LoginLink from "@core/layouts/header/components/common/LoginLink";
import LinkUtil from "@features/auth/component/userInfo/beforeLogin/LinkUtil";
import { Button } from "@core/components/ui/Button";
import { cn } from "@core/utils/domUtil";

const containerClassName = "flex h-full flex-col items-center justify-center  pb-[60px]";

export default function UserInfoBeforeLoginMobile() {
  const [isNcfzLogin, setIsNcfzLogin] = useState(false);

  const clickHandler = useCallback(() => {
    setIsNcfzLogin(true);
  }, []);

  return isNcfzLogin ? (
    <div className={cn(containerClassName)}>
      <Heading level={2} className="mb-[24px] text-lg">
        NC Family ZONE 로그인
      </Heading>
      <NcfzLogin />
      <div className="mt-[44px] w-full">
        <LinkUtil userType="ncfz" />
      </div>
    </div>
  ) : (
    <div className={cn(containerClassName, "gap-[20px]")}>
      <LoginLink variant="bgPoint600" size="large" className="w-full">
        PLAYNC 로그인
      </LoginLink>
      <Button variant="bgPoint600" size="large" className="w-full" onClick={clickHandler}>
        NC Family ZONE 로그인
      </Button>
    </div>
  );
}
